<template>
  <div class="pagination-content" @click.stop>
    <div class="pagination-content__text">
      מציג {{ viewCount }} מתוך {{ countUsers }} תוצאות
    </div>
    <div class="pagination-content__button">
      <NewButton
        color="secondary"
        :text="'הצג עוד'"
        @click="$emit('clickPagination')"
      ></NewButton>
    </div>
  </div>
</template>

<script>
import NewButton from './NewButton.vue';
export default {
  components: {
    NewButton
  },
  props: {
    countUsers: {
      type: Number
    },
    viewCount: {
      type: Number
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination-content {
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-top: 8px;
  gap: 8px;
  margin-bottom: 8px;
  &__text {
    font-size: 12px;
    color: rgba(56, 69, 93, 1);
    font-family: Rubik;
    line-height: 16px;
  }
}
</style>
